module.exports = __webpack_public_path__ + "static/img/7.46e2839.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/main/7.jpg
// module id = bm7Z
// module chunks = 0